import { HStack, Tag } from '@chakra-ui/react'

const BlogTags = ({tags}) => (
	<HStack spacing={2}>
		{tags.map((tag) => <Tag size={'md'} variant="solid" colorScheme="purple" key={tag}>{tag}</Tag>)}
	</HStack>
)

export default BlogTags